import React from 'react';
import classNames from 'classnames';

import styles from './Dropdown.module.scss';

export interface MenuProps {
  className?: string;
  isOpen?: boolean;
  // handleToggle?: () => void;
}

const Menu: React.FC<MenuProps & React.HTMLAttributes<HTMLDivElement>> = props => {
  const { children, className, isOpen, ...restProps } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <div className={classNames(styles.dropdown, className)} {...restProps}>
      <ul>
        {/* <li>{child}</li> */}
        {React.Children.map(children, child => child)}
      </ul>
    </div>
  );
};

export default Menu;
